class OptionException extends Error {
  constructor(type: string, value: string) {
    super(`Can\`t find '${value}' in '${type}' type`);
  }
}

export default OptionException;
